import React from "react";
import { Colors } from "../../../utils/colors";

type props = {
  bookingId: number;
};

export const MatchBookingId: React.FC<props> = ({ bookingId }) => {
  return (
    <span style={{ fontWeight: 600, fontSize: 14, color: Colors.black }}>
      Booking ID: <span>{bookingId}</span>
    </span>
  );
};
